export default {
    getters: {
        $tracker: () => window.gtmTracker
    },
    methods: {
        /**
         * send a transaction to Google Tag Manager.
         * @param  {string} transactionId right now it's a comma-separated string of all subscription id's
         * @param  {object} orderLines    in the same structure that is used to send the order server-side.
         */
        trackPlacedOrder(transactionId, orderLines) {
            let transactionTotal = 0;

            let productList = [];

            Object.keys(orderLines).forEach(category => {
                orderLines[category].forEach(productData => {
                    productList.push({
                        sku: productData.name + productData.period + productData.status,
                        name: productData.name + ' ' + productData.period + ' maanden ' + productData.status,
                        category,
                        price: productData.price,
                        quantity: 1
                    });
                    transactionTotal += productData.price;
                });
            });
            window.gtmTracker.sendTrackedEvent({
                transactionId: transactionId,
                transactionAffiliation: 'Realhosting',
                transactionTotal: transactionTotal,
                transactionTax: 0,
                transactionShipping: 0,
                transactionProducts: productList
            });
        }
    }
};
